import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

export const canDelete = (o) => o.order_type === "customer" && !["shipped", "short_shipped"].includes(o.status);

export const DeleteOrderDialog = ({ order, onOpenChange, onDone }) => {
  const run = async () => {
    try {
      await api.delete(`/orders/${order.id}`);
      toast.success(`PO ${order.po_number} deleted and moved to the archive`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <AlertDialog open={!!order} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-slate-800 bg-[#1F232C] text-slate-100" data-testid="delete-order-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">Delete PO {order?.po_number}?</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            The order moves to the archive and can be restored. EDI messages stay in the EDI Log.
            {order?.edi_940_id && <span className="mt-2 block text-amber-300" data-testid="delete-order-940-warning">A 940 has already been sent for this order. It is not recalled, so tell Group O separately.</span>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800" data-testid="delete-order-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={run} className="bg-red-600 text-white hover:bg-red-500" data-testid="delete-order-confirm-btn">Delete order</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
